import { useId } from 'react';
import { oapOutcomeCards, type BoardPick } from '../logic/dashboard';

interface CmsGoalsSectionProps {
  filters?: unknown[];
  selected?: string[];
  onPick: (pick: BoardPick) => void;
}

// Health only, never tasks: where each aligned patient stands against their CMS goals today.
export default function CmsGoalsSection({ filters = [], selected = [], onPick }: CmsGoalsSectionProps) {
  const titleId = useId();
  const cards = oapOutcomeCards(filters, selected);
  if (!cards) return null;
  return (
    <section className="board-section" aria-labelledby={titleId}>
      <div className="board-section__head">
        <h2 className="board-section__title" id={titleId}>CMS goals</h2>
        <span className="board-section__note">aligned patients · today’s values against each patient’s CMS goals</span>
      </div>
      <div className="goal-cards">
        {cards.map((c) => {
          const on = selected.includes(c.value);
          // As on the journey chips: a card at 0 does nothing unless it is the selected one.
          const disabled = c.count === 0 && !on;
          return (
            <button
              key={c.value}
              type="button"
              className={`goal-card${on ? ' is-selected' : ''}${disabled ? ' is-empty' : ''}`}
              aria-pressed={on}
              aria-disabled={disabled || undefined}
              aria-label={`Filter roster: ${c.label}, ${c.count} ${c.count === 1 ? 'patient' : 'patients'}`}
              onClick={() => { if (!disabled) onPick({ key: 'oap_outcome', value: c.value }); }}
            >
              <span className="goal-card__title">
                <span className={`goal-dot is-${c.tone}${c.value === 'missing' ? ' is-missing' : ''}`} aria-hidden="true" />
                {c.label}
              </span>
              <span className="goal-card__value">
                <span className="goal-card__count">{c.count}</span>
                <span className="goal-card__sub">{c.sub}</span>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
